{
  "version": 1,
  "asset_id": "cf3502a5-a112-469d-a431-36febfbf6ccd",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/cf3502a5-a112-469d-a431-36febfbf6ccd/hewes-craft-boat.png",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/cf3502a5-a112-469d-a431-36febfbf6ccd/hewes-craft-boat.png",
  "original_filename": "hewes-craft-boat.png",
  "size": 2504679,
  "content_type": "image/png",
  "created_at": "2026-07-03T00:06:07Z"
}
